import React from "react";

import LogoBlack from './img/welltory-logo-black.svg';
import Logo from './img/welltory-logo.svg';

import styles from './styles.module.scss';

export default function SurveyHeader({
  align = 'left',
  theme = 'white',
}: {
  align?: string;
  theme?: string;
}) {
  return (
    <div style={{ justifyContent: align }} className={styles.surveyHeader}>
      {theme === 'white' ? <LogoBlack className={styles.logo} height="32" /> : <Logo className={styles.logo} height="32" />}
    </div>
  );
};
